import { InputBase } from './input-base';
/**
 * DropdownInput Component.
 */
export class DropdownInput extends InputBase<string>{
    controlType = 'dropdown';
}